import { escapeRegExp } from 'lodash'

type TextSegment = {
  text: string
  isMatch: boolean
}

// Splits text into segments marking the case-insensitive occurrences of query.
export const splitTextByMatch = (
  text: string,
  query?: string,
): TextSegment[] => {
  const normalizedQuery = query?.trim()
  if (!normalizedQuery) return [{ text, isMatch: false }]

  return (
    text
      .split(new RegExp(`(${escapeRegExp(normalizedQuery)})`, 'i'))
      // With a single capture group, odd indices are the captured matches.
      .map((segment, index) => ({ text: segment, isMatch: index % 2 === 1 }))
      .filter((segment) => segment.text)
  )
}
